import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { showSuccessFlag } from '@helpcenter/flags';
import { hideFeedbackCollector, updateAdditionalFieldsInFeedbackCollector } from 'state/actions/feedback-collector';
import {
    getShouldOpenFeedbackWidget,
    getShowTypeField,
    getAdditionalFields,
    getCustomComponent,
} from 'state/selectors/feedback-collector';
import { getDisplayName, getUserState } from 'state/selectors/user';
import { getEnv } from '@atlassian/help-center-common-util/env';
import FeedbackCollector from './feedback-collector';

const selector = createSelector(
    getUserState,
    getDisplayName,
    getShouldOpenFeedbackWidget,
    getShowTypeField,
    getAdditionalFields,
    getCustomComponent,
    getEnv,
    (userState, name, shouldOpenFeedbackWidget, showTypeField, additionalFields, CustomComponent, env) => ({
        name,
        showTypeField,
        additionalFields,
        CustomComponent,
        isOpen: shouldOpenFeedbackWidget,
        email: userState.email,
        env: env.environment,
    })
);

const mapDispatchToProps = {
    hideFeedbackCollector,
    updateAdditionalFieldsInFeedbackCollector,
    showSuccessFlag,
};

export default connect(selector, mapDispatchToProps)(FeedbackCollector);
